import angular from 'angular';
import MySlowMovingGamesWidgetComponent from './my-slow-moving-games-widget-component';

export default angular
  .module('my-slow-moving-games-widget', [])
  .component('mySlowMovingGamesWidget', new MySlowMovingGamesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/my-slow-moving-games/my-slow-moving-games-widget-module.js